<script lang="ts" setup>
import NotificationDropdown from '@/common/components/navbar/components/dropdowns/NotificationDropdown.vue'
import ProfileDropdown from '@/common/components/navbar/components/dropdowns/ProfileDropdown.vue'
import TenantDropdown from '@/common/components/navbar/components/dropdowns/TenantDropdown.vue'
import { useUserStore } from '@/common/stores/user-store'
import { computed, inject, onMounted, ref } from 'vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const store = useUserStore()
const tenantId = computed(() => store.tenantId)

const getDisplayName = inject<() => Promise<string>>('get-display-name')!
const displayName = ref('')
onMounted(async () => {
  displayName.value = await getDisplayName()
  store.displayName = displayName.value
})

const hasTenants = tenantId.value !== null && tenantId.value !== '' //&& store.tenantList.length > 1
</script>

<template>
  <div class="app-navbar-actions">
    <span v-if="!hasTenants" class="app-navbar-actions__item username-display">
      {{ displayName }}
    </span>
    <TenantDropdown v-if="hasTenants" class="app-navbar-actions__item mr-0" />
    <NotificationDropdown class="app-navbar-actions__item" />
    <ProfileDropdown class="app-navbar-actions__item app-navbar-actions__item--profile mr-1" />
  </div>
</template>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }

  &__item {
    padding: 0;
    margin-left: 0.25rem;
    margin-right: 0.25rem;

    svg {
      height: 20px;
    }

    &--profile {
      display: flex;
      justify-content: center;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 640px) {
      margin-left: 0;
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .username-display {
    font-weight: 600;
    color: var(--va-primary);
    font-size: clamp(0.8rem, 2.5vw, 1rem);
  }
}
</style>
